import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TickerContextType {
    text: string;
    setText: (text: string) => void;
}

const TickerContext = createContext<TickerContextType | undefined>(undefined);

export function TickerProvider({ children }: { children: ReactNode }) {
    const [text, setText] = useState('');

    return (
        <TickerContext.Provider value={{ text, setText }}>
            {children}
        </TickerContext.Provider>
    );
}

export function useTicker() {
    const context = useContext(TickerContext);
    if (context === undefined) {
        throw new Error('useTicker must be used within a TickerProvider');
    }
    return context;
}
